import React from 'react'
import './Footer.css';
const Footer = () => {
  const currentYear = new Date().getFullYear();
  return (
    <footer>
   <div className='copy-cont'>
  Copyright © {currentYear} Ram Thanganagai Maligai | Powered by   
  <span className="tech-container"> 
          <span className="thofa-text">THOFA</span>
          <span className="technologies-text"> TECHNOLOGIES</span>
        </span>
      </div>
      </footer>
  )
}
export default Footer
